<template>
  <modal
    v-slot="{ data }"
    name="ageVerificationModal"
    modal-style="compact"
    :is-required="true"
  >
    <age-verification
      v-if="data.onConfirm"
      :required="data.required"
      @confirmed="data.onConfirm"
    />

    <age-verification
      v-else
      :required="data.required"
    />
  </modal>
</template>


<script>
  import AgeVerification from './age-verification/index.vue';


  export default {
    name: 'AgeVerificationModal',

    components: {
      AgeVerification
    }
  };
</script>
